import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import "./ViewPage.css";
import axios from "axios";

/*
  ViewStaffAttendance
  - Uses the same visual structure as CustomerView so all view pages are consistent.
  - Field / Value table is inside .customer-details-table-wrapper so it scrolls horizontally
    inside .outer-container on small screens instead of breaking into stacked rows.
*/

const ViewStaffAttendance = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [attendance, setAttendance] = useState(null);

  useEffect(() => {
    axios.post(`${API_BASE_URL}attendance_detail.php`, { att_id: id })
      .then((response) => {
        if (response.data.head.code === 200) {
          setAttendance(response.data.body);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setAttendance([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setAttendance([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  if (!attendance) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">View Staff Attendance</h2>
        <Row>
          <Col>
            <div className="not-found-box">Loading...</div>
          </Col>
        </Row>
      </Container>
    );
  }

  // build fields array so rendering is consistent and easy to extend
  const fields = [
    { label: "Name", value: attendance.user_name },
    { label: "Designation", value: attendance.desig_name },
    { label: "Department", value: attendance.depart_name },
    { label: "Date", value: attendance.att_date },
    { label: "Time", value: attendance.att_time },
    { label: "Action", value: attendance.status },
  ];

  return (
    <Container fluid className="outer-container my-4">
      <h2 className="text-center mb-3">View Staff Attendance</h2>

      <div className="customer-header d-flex justify-content-end align-items-center mb-3">
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="customer-view-wrapper">
        <div className="customer-view-card">
          {/* optional photo column left blank for attendance view; kept for consistent layout */}
          <div className="customer-photo-wrap" aria-hidden>
            {/* empty to preserve layout; add an icon or avatar if desired */}
          </div>

          <div className="customer-details-table-wrapper">
            <table
              className="customer-view-table"
              role="table"
              aria-label={`Attendance details for ${attendance.name}`}
            >
              {/* <thead>
                <tr>
                  <th style={{ width: "36%" }}>Field</th>
                  <th style={{ width: "64%" }}>Value</th>
                </tr>
              </thead> */}
              <tbody>
                {fields.map((f, i) => (
                  <tr key={i}>
                    <td className="field-cell">{f.label}</td>
                    <td className="value-cell">{f.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ViewStaffAttendance;
